
import { Component, Input, OnChanges, Output, EventEmitter, ViewChild, OnInit, OnDestroy, ElementRef, AfterViewInit } from '@angular/core';

import { FieldTypeListParentService } from './../utils/field-type-list-parent.service';

import { CustomLandingFactory } from '@shared/factories/custom-landing/custom-landing.factory';
import { ByWordPipe } from '../../../filters/by-word/by-word.pipe';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';
import { AfOrderByPipe } from '@shared/filters/af-order-by/af-order-by.pipe';
import { TreeListChildrenComponent } from '../tree-list-children/tree-list-children.component';
import { AfTranslateDirective } from '../../../modules/translate/directive/af-translate.directive';
import { FormsModule } from '@angular/forms';
import { SpanTooltipComponent } from '../../span-tooltip/span-tooltip.component';
import { TooltipModule } from 'primeng/tooltip';
import { TooltipLawComponent } from '../../tooltip-law/tooltip-law.component';
import { TooltipInfoComponent } from '../../tooltip-info/tooltip-info.component';
import { NgClass, NgStyle } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';
import { DocumentActionsService } from '@shared/services/document-actions/document-actions.service';
import { TooltipInReportComponent } from "../../tooltip-in-report/tooltip-in-report.component";

@Component({
    selector: 'field-type-list-simple',
    templateUrl: './field-type-list-simple.component.html',
    standalone: true,
    imports: [NgClass,
      TooltipInfoComponent,
      TooltipLawComponent,
      TooltipModule,
      SpanTooltipComponent,
      NgStyle,
      FormsModule,
      AfTranslateDirective,
      TreeListChildrenComponent,
      AfOrderByPipe,
      AfTranslatePipe,
      ByWordPipe,
      OverlayPanelModule,
      TooltipInReportComponent
    ]
})
export class FieldTypeListSimpleComponent implements OnChanges, OnInit, AfterViewInit, OnDestroy {
  conceptObjectId:string = this.route.snapshot.params['conceptObjectId']
  selectionAsArray:boolean = false;
  isLanding = this.customLanding.isLanding();
  fieldTypeList:any = this.fieldTypeListParent.configureFieldTypeList(this);

  constructor(
    private route: ActivatedRoute,
    private customLanding: CustomLandingFactory,
    private documentActions: DocumentActionsService,
    private fieldTypeListParent: FieldTypeListParentService ) {
  }

  @Input() field:any = {};
  @Input() concept:any;
  @Input() preSelectItem:any = '';
  @Input() listValues:any = [];
  @Input() listAll:any = [];
  @Input() public: boolean = false;
  @Input() type:any = '';
  @Input() orderBy: string = 'text';
  @Input() fieldToFind: string = 'text';
  @Output() itemSelected = new EventEmitter();
  @Output() openRelatedInfo = new EventEmitter();
  @ViewChild('containerFieldList') containerFieldListElement: ElementRef;
  @ViewChild('fieldTypeListSimpleOverlay') fieldTypeListSimpleOverlay: OverlayPanel;

  ngAfterViewInit(): void {
    this.fieldTypeListParent.configureAfterViewInit(this.fieldTypeListSimpleOverlay);
  }

  ngOnInit(): void {
    this.fieldTypeListParent.openWatchers(this);
  }

  ngOnChanges(): void {
    this.fieldTypeListParent.configureChanges(this);
  }

  catchEvent(e:any){
    e.stopPropagation();
  }

  createNewValue(){
    if(this.field.type === 'customTemplate'){
      this.addNewDocument();
    }else{
      this.fieldTypeListParent.createNewValue(this);
    }
  }

  addNewDocument(){
    let configuration: any = {
      concept: this.concept,
      templatesList: this.listValues,
      listTemplates: this.listValues
    }
    this.fieldTypeListSimpleOverlay.hide();
    this.documentActions.newDocument(configuration)
      .then((data: any)=>{
        this.fieldTypeList.filterList.push(data);
        for(let i = 0; i < this.fieldTypeList.filterList.length; i++){
          if(data.listValueId === this.fieldTypeList.filterList[i].listValueId){
            this.selectItem(this.fieldTypeList.filterList[i]);
            break;
          }
        }
      }, (errorData:any)=>{});
  }

  insertNewValue(){
    this.fieldTypeListParent.insertNewValue(this);
  }

  editListValueElement(listValue:any){
    this.fieldTypeListParent.editListValueElement(listValue, this);
  }

  deleteListValue(listValue:any){
   this.fieldTypeListParent.deleteListValue(listValue, this)
  }

  aceptNotDelete(){
    this.fieldTypeList.deleteError = false;
  }

  resetListValue(){
    this.fieldTypeListParent.resetListValue(this);
  }

  selectItem(listValue: any, action: any = ''){
    if((this.field.uniqueLastSelect && listValue.children?.length) || action === 'showChildren'){
      this.showChildren(listValue);
    }else if(!listValue.disabled){
      this.fieldTypeListParent.selectItem(listValue, this);
      this.fieldTypeListSimpleOverlay.hide();
    }
  }

  closeList(){
    this.fieldTypeListParent.closeList(this);
  }

  closeAllElements(list: any, listValueSelected: any, children: boolean = false){
    for(let i = 0; i < list.length; i++){
      let listValue = list[i];
    // list.forEach((listValue: any) => {
      if(listValueSelected.listValueId === listValue.listValueId){
        listValue.show = true;
      }else if(listValue.children?.length){
        listValue.show = this.closeAllElements(listValue.children, listValueSelected, true);
      }else {
        listValue.show = false;
      }
      if(children && listValueSelected.listValueId === listValue.listValueId){
        return true;
      }
      // if(listValueSelected.parentId !== listValue.listValueId && listValueSelected.listValueId !== listValue.listValueId){
      //   listValue.show = false;
      // }else if(listValue.parentId){
      //   this.openParent(this.fieldTypeList.filterList, listValue);
      // }
      // if(listValue.children?.length){
      //   this.closeAllElements(listValue.children, listValueSelected);
      // }
    // });
    }
    return false;
  }

  // openParent(list: any, listValueSelected: any){
  //   list.forEach((listValue: any) => {
  //     if(listValueSelected.parentId === listValue.listValueId){
  //       listValue.show = true;
  //     }
  //     if(listValue.children?.length){
  //       this.openParent(listValue.children, listValueSelected);
  //     }
  //   });
  // }

  showChildren(listValue:any){
    this.closeAllElements(this.fieldTypeList.filterList, listValue);
    // listValue.show = !listValue.show;
  }

  changeList(){
    this.fieldTypeListParent.changeList(this);
  }

  resetSearch(){
    this.fieldTypeListParent.resetSearch(this);
  }

  openModalRelatedInfo(fieldRelatedInfo:any){
    this.fieldTypeListParent.openModalRelatedInfo(fieldRelatedInfo, this);
  }

  resetItem(){
    this.fieldTypeListParent.resetItem(this);
  }

  treeSimpleOn(event:any){
    this.selectItem(event.listValue, event.action);
  }

  checkListValue(listValue:any){
    return !(listValue?.type?.toLowerCase()==='back' && !listValue.show);
  }

  toggleFilter(e: any){
    this.fieldTypeListParent.toggleFilter(e, this.fieldTypeListSimpleOverlay, this);
  }

  ngOnDestroy(){
    this.fieldTypeListParent.ngOnDestroy();
  }
}
